import { render, staticRenderFns } from "./DropdownMenuItem.vue?vue&type=template&id=39e76197&"
import script from "./DropdownMenuItem.vue?vue&type=script&lang=ts&"
export * from "./DropdownMenuItem.vue?vue&type=script&lang=ts&"
import style0 from "./DropdownMenuItem.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports